import { render, staticRenderFns } from "./New.vue?vue&type=template&id=c4d15f5c&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=c4d15f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d15f5c",
  null
  
)

export default component.exports